import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { disclaimNvr } from "lib/actions";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import Modal from "react-modal";
import { ConfirmModalStyles } from "lib/constants";
import { showToast } from "ui/components/common";
import { SideviewContext } from "context/SideviewContext";
import { useSWRConfig } from "swr";
import { Alert, Select } from "antd";
import { changeNvrType, getNvrById, resetGps, useWSService } from "./service";
import { copyToClipBoard } from "lib/utils";
import dayjs from "dayjs";
import _ from "lodash";
export default function Form({
  orgId,
  siteId,
  objData,
}: {
  orgId: string;
  siteId: string;
  objData: any;
}) {
  const [removeNvrConfirmModalOpen, setRemoveNvrConfirmModalOpen] =
    useState(false);
  const { setOpenPanel, setViewData } = useContext(SideviewContext);
  const { mutate: globalMutate } = useSWRConfig();
  const { user } = useContext(AuthContext);
  const [typeLoading, setTypeLoading] = useState(false);
  const navigate = useNavigate();
  const { testSpeed, upgradeEdge } = useWSService();
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  async function handleRemoveNvr(nvrId) {
    try {
      // console.log("Removing NVR with siteId = ", siteId, 'nvrId = ', nvrId);
      await disclaimNvr(orgId, "", nvrId);
      showToast(0, "The NVR has been removed successfully!");
      const params = `?siteId=${siteId}&page.limit=100`;
      globalMutate([`/device/nvrs${params}`, user.token, orgId]);
      setOpenPanel(false);
      // navigate(0);
    } catch (error) {
      console.error(error);
      navigate(`?modal=true&content=${error}`);
    }
  }
  async function handleTypeChange(value) {
    setTypeLoading(true);
    const res = await changeNvrType(objData.id, value, orgId);
    if (res.status === 200) {
      setViewData((state) => {
        state.objData.type = value;
        state.objData.isTrailer = value !== "normal";
        state.objData.nmeaUrl = res.data?.nmeaUrl;
        return { ...state };
      });
      showToast(0, "The NVR type has been changed successfully");
    } else {
      showToast(1, "The NVR type has been changed failed");
    }
    setTypeLoading(false);
  }
  function onLocationCopyClick() {
    copyToClipBoard(
      `${objData.geolocation?.latitude},${objData.geolocation?.longitude}`,
    );
  }
  function onNMEACopy() {
    copyToClipBoard(objData.nmeaUrl);
  }
  async function onReset() {
    const res = await resetGps(objData.id, orgId);
    if (res.status === 200) {
      setViewData((state) => {
        state.objData.geolocation = res.data?.geolocation;
        state.objData.nmeaUrl = res.data?.nmeaUrl;
        return { ...state };
      });
      showToast(0, "The GPS has been reset successfully");
    } else {
      showToast(1, "The GPS has been reset failed");
    }
  }
  const [speedTestloading, setSpeedTestLoading] = useState(false);
  useEffect(() => {
    if (objData.testStatus === "testing") setSpeedTestLoading(true);
  }, [objData.testStatus]);
  async function onSpeedTest() {
    setSpeedTestLoading(true);
    try {
      const res: any = await testSpeed(orgId, objData.deviceId);
      setViewData((state) => {
        state.objData.bandwidthLimit =
          res.deviceSpeedTestReplyRes.bandwidthLimit;
        state.objData.testBandwidth = res.deviceSpeedTestReplyRes.testBandwidth;
        state.objData.lastTestedAt = res.deviceSpeedTestReplyRes.lastTestedAt;
        return { ...state };
      });
    } catch (e) {
      if (e.message.indexOf("4020") !== -1) {
        showToast(1, "A test is already in progress");
      } else if (e.message.indexOf("4023") !== -1) {
        showToast(
          1,
          "Bandwidth is too low, please test again in a better network environment.",
        );
      } else {
        showToast(1, "Speed Test Failed. Error:" + e);
      }
    } finally {
      setSpeedTestLoading(false);
    }
  }
  const upgradable = () => {
    if (
      ["success", "failed", "empty"].includes(objData.upgrade.upgradingState) &&
      objData.status === "online"
    ) {
      const nvr_edge = objData.upgrade?.services?.find(
        (item) => item.service === "nvr_edge",
      );
      if (nvr_edge && nvr_edge.upgradable === "need_upgrade") {
        return true;
      }
    }
    return false;
  };
  const upgrade = async () => {
    setUpgradeLoading(true);
    try {
      await upgradeEdge(orgId, objData.id);
      setUpgradeLoading(false);
      setViewData((state) => {
        const _state = _.cloneDeep(state);
        _state.objData.upgrade.upgradingState = "upgrading";
        const nvr_edge = _state.objData.upgrade?.services?.find(
          (item) => item.service === "nvr_edge",
        );
        nvr_edge.upgradingState = "upgrading";
        return _state;
      });
      const intervalId = setInterval(() => {
        getNvrById(objData.id, orgId).then((data) => {
          const nvr = data.data.data;
          if (!["upgrading", "initial"].includes(nvr.upgrade.upgradingState)) {
            if (nvr.upgrade.upgradingState === "success")
              showToast(0, "Upgrade result:" + nvr.upgrade.upgradingState);
            else showToast(1, "Upgrade result:" + nvr.upgrade.upgradingState);
            clearInterval(intervalId);
            setViewData((state) => {
              const _state = _.cloneDeep(state);
              _state.objData.upgrade = nvr.upgrade;
              return _state;
            });
          }
        });
      }, 1000);
    } catch (e) {
      setUpgradeLoading(false);
      showToast(1, "Upgrade failed");
    }
  };
  return (
    <>
      <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
        <table className="table-auto gap-y-3">
          <tbody>
            <tr>
              <td className="pb-3 text-neutral-500">Model</td>
              <td className="pb-3 pl-3">{objData.model}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500">Vendor</td>
              <td className="pb-3 pl-3">{objData.manufacturer}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">MAC Address</td>
              <td className="pb-3 pl-3">{objData.macAddress}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">
                Serial Number
              </td>
              <td className="pb-3 pl-3">{objData.sn}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">External IP</td>
              <td className="pb-3 pl-3">{objData.externalIp}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Internal IP</td>
              <td className="pb-3 pl-3">{objData.ips?.at(0)}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">
                Firmware Version
              </td>
              <td className="pb-3 pl-3">{objData.firmwareVersion}</td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">
                Edge Version
              </td>
            </tr>
            <tr>
              <td className="pb-3  text-nowrap">Current Version</td>
              <td className="pb-3 pl-3">
                {objData.upgrade?.services?.find(
                  (item) => item.service === "nvr_edge",
                )?.version || "-"}
              </td>
            </tr>
            <tr>
              <td className="pb-3  text-nowrap">Target Version</td>
              <td className="pb-3 pl-3">
                {objData.upgrade?.services?.find(
                  (item) => item.service === "nvr_edge",
                )?.targetVersion || "-"}
              </td>
            </tr>
          </tbody>
        </table>
        {["upgrading", "initial"].includes(
          objData.upgrade?.services?.find((item) => item.service === "nvr_edge")
            ?.upgradingState,
        ) && (
          <Alert
            style={{ marginBottom: "12px" }}
            message="Upgrading, please do not turn off or restart the device."
            type="info"
            showIcon
          />
        )}
        {["failed"].includes(
          objData.upgrade?.services?.find((item) => item.service === "nvr_edge")
            ?.upgradingState,
        ) && (
          <Alert
            style={{ marginBottom: "12px" }}
            message="Upgrade failed, please Try Again or contact support.."
            type="error"
            showIcon
          />
        )}
        <div style={{ display: "flex", justifyContent: "end", width: "100%" }}>
          <Button
            disabled={!upgradable()}
            className="primaryButton"
            onClick={upgrade}
            loading={upgradeLoading}
          >
            Upgrade Edge
          </Button>
        </div>
      </div>
      {objData.isTrailer && (
        <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "600" }}>GPS</span>
            <span
              style={{ cursor: "pointer", color: "#3E83F6", fontWeight: "600" }}
              onClick={onLocationCopyClick}
            >
              Copy
            </span>
          </div>
          <table className="table-auto gap-y-3 mt-3">
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Latitude</td>
              <td className="pb-3 pl-3">
                {objData.geolocation?.latitude
                  ? Number(objData.geolocation?.latitude).toFixed(6)
                  : "-"}
              </td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Longitude</td>
              <td className="pb-3 pl-3">
                {objData.geolocation?.longitude
                  ? Number(objData.geolocation?.longitude).toFixed(6)
                  : "-"}
              </td>
            </tr>
            <tr>
              <td className="pb-3 text-neutral-500 text-nowrap">Device SN</td>
              <td className="pb-3 pl-3">
                {objData.geolocation?.serialNum || "N/A"}
              </td>
            </tr>
          </table>
          {objData.geolocation?.ts && Number(objData.geolocation?.ts) && (
            <div style={{ width: "100%" }}>
              <span style={{ color: "#222222" }}>
                {"Updated on " +
                  dayjs(Number(objData.geolocation?.ts)).format(
                    "YYYY-MM-DD HH:mm:ss",
                  )}
              </span>
            </div>
          )}
          <div
            style={{
              width: "100%",
              border: "1px solid #E1E1E1",
              margin: "12px 0px",
            }}
          ></div>
          <div style={{ width: "100%", color: "#222222" }}>
            Please click the reset button if you want to rebind to a new GPS
            device.
          </div>
          <div style={{ marginTop: "12px" }}>
            <span
              style={{
                cursor: "pointer",
                color: "#3E83F6",
                fontWeight: "600",
              }}
              onClick={onReset}
            >
              Reset
            </span>
          </div>
        </div>
      )}

      <div className="bg-zinc-50  p-3 mt-3 rounded-lg mb-3">
        <div className="mt-3 rounded-lg mb-2"> Type</div>
        <Select
          style={{ width: "100%", height: "54px", borderRadius: "16px" }}
          options={[
            { label: "Normal", value: "normal" },
            { label: "Trailer", value: "trailer" },
            { label: "Robot", value: "robot" },
            { label: "Guardbox", value: "guardbox" },
          ]}
          onChange={handleTypeChange}
          loading={typeLoading}
          value={objData.type}
        />
        {objData.isTrailer && (
          <>
            {objData.nmeaUrl && (
              <>
                <div
                  className="mt-4"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span>HTTPS URL OF GPS</span>
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#3E83F6",
                      fontWeight: "600",
                    }}
                    onClick={onNMEACopy}
                  >
                    Copy
                  </span>
                </div>
                <div
                  className="mt-2"
                  style={{
                    width: "100%",
                    whiteSpace: "pre-wrap",
                    overflowWrap: "anywhere",
                  }}
                >
                  {objData.nmeaUrl}
                </div>
              </>
            )}
            {!objData.geolocation?.serialNum && (
              <div style={{ marginTop: "16px" }}>
                <Alert
                  style={{
                    borderRadius: "16px",
                    border: "none",
                    backgroundColor: "#FFF7D6",
                  }}
                  showIcon
                  message="Please paste this url into the HTTPS URL OF GPS of a GPS device"
                  type="warning"
                />
              </div>
            )}
          </>
        )}
      </div>
      <div className="bg-zinc-50 p-3 mt-3 rounded-lg mb-3">
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "130px" }}>
            <div style={{ color: "#222222", textWrap: "nowrap" }}>
              Network Bandwidth
            </div>
            <div style={{ marginTop: "8px" }}>
              {objData.testBandwidth
                ? objData.testBandwidth / 1000 + "Mbps"
                : "Not Tested Yet"}
            </div>
            <div
              style={{
                color: "#222222",
                marginTop: "16px",
                textWrap: "nowrap",
              }}
            >
              Current Speed Limit
            </div>
            <div style={{ marginTop: "8px" }}>
              {objData.bandwidthLimit
                ? objData.bandwidthLimit / 1000 + "Mbps"
                : "N/A"}
            </div>
          </div>
          <Button
            className="primaryButton"
            loading={speedTestloading}
            onClick={onSpeedTest}
          >
            Test
          </Button>
        </div>
        <div style={{ width: "100%", marginTop: "12px" }}>
          <span style={{ color: "#222222" }}>
            {objData.lastTestedAt
              ? "Updated on " +
                dayjs(Number(objData.lastTestedAt)).format(
                  "YYYY-MM-DD HH:mm:ss",
                )
              : ""}
          </span>
        </div>
      </div>

      <div className="flex justify-between">
        <button
          className="flex items-center rounded-2xl bg-white px-[24px] py-[14px] text-base font-semibold text-blue-500 border border-blue-500 transition-colors hover:text-blue-400 hover:border-blue-400 "
          onClick={() => {
            setOpenPanel(false);
          }}
        >
          Close
        </button>
        <Button
          className="primaryButton danger"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            // setRemovedNvrId(objData.id);
            setRemoveNvrConfirmModalOpen(true);
          }}
        >
          <span className="text-red-500 hover:text-red-400">Delete</span>
        </Button>
      </div>
      <Modal
        isOpen={removeNvrConfirmModalOpen}
        style={ConfirmModalStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl font-bold">Do you want to delete the nvr?</h1>
        <div className="text-base mt-4">
          This nvr will be permanently deleted from this site.
        </div>

        <div className="float-right mt-6">
          <button
            className="rounded-2xl bg-white px-6 py-4 border border-blue-500 hover:border-blue-400 text-sm  transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemoveNvrConfirmModalOpen(false);
            }}
          >
            Cancel
          </button>
          <button
            className="ml-4 rounded-2xl px-6 py-4 bg-red-500 text-sm font-medium text-white transition-colors hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500 active:bg-red-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            onClick={() => {
              setRemoveNvrConfirmModalOpen(false);
              handleRemoveNvr(objData.id);
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
}
